var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions-collapsed-list" },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-function exit-collapsed-list",
          on: { click: _vm.collapseActions }
        },
        [
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.right.hover",
                value: _vm.$t("CANCEL"),
                expression: "$t('CANCEL')",
                modifiers: { right: true, hover: true }
              }
            ],
            staticClass: "glyphicon glyphicon-chevron-left",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _vm.createAccess
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-list-function",
                attrs: { "data-testid": "buyer-action-edit", href: _vm.href },
                on: { click: _vm.showForm }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right.hover",
                      value: _vm.$t("BUYERS_ACTIONS_EDIT"),
                      expression: "$t('BUYERS_ACTIONS_EDIT')",
                      modifiers: { right: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-edit",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "BUYERS_ACTIONS_EDIT",
                      expression: "'BUYERS_ACTIONS_EDIT'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-list-function",
            attrs: {
              disabled: _vm.disabled,
              "data-testid": "buyer-action-invites"
            },
            on: { click: _vm.showInvites }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.right.hover",
                  value: _vm.$t("MANAGE_USER_INVITES"),
                  expression: "$t('MANAGE_USER_INVITES')",
                  modifiers: { right: true, hover: true }
                }
              ],
              staticClass: "fa m-t-4 fa-user-plus",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "MANAGE_USER_INVITES",
                  expression: "'MANAGE_USER_INVITES'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.isAdmin
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-list-function",
                attrs: { disabled: _vm.disabled },
                on: { click: _vm.resetCapCounters }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.left.hover",
                      value: _vm.$t("RESET_CAP_COUNTERS"),
                      expression: "$t('RESET_CAP_COUNTERS')",
                      modifiers: { left: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-arrow-loop"
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "RESET_CAP_COUNTERS",
                      expression: "'RESET_CAP_COUNTERS'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdmin
        ? _c("div", { staticClass: "action-icon m-l-3" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-list-function",
                attrs: { disabled: _vm.disabled },
                on: { click: _vm.showReferences }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.left.hover",
                      value: _vm.$t("BUYER_ACTIONS_SHOW_REFERENCES"),
                      expression: "$t('BUYER_ACTIONS_SHOW_REFERENCES')",
                      modifiers: { left: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-flow-children",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "BUYER_ACTIONS_SHOW_REFERENCES",
                      expression: "'BUYER_ACTIONS_SHOW_REFERENCES'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-list-function",
            attrs: {
              disabled: _vm.disabled,
              "data-testid": "buyer-action-delete"
            },
            on: { click: _vm.confirmDelete }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.right.hover",
                  value: _vm.$t("BUYERS_DELETE"),
                  expression: "$t('BUYERS_DELETE')",
                  modifiers: { right: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-trash",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "BUYERS_DELETE",
                  expression: "'BUYERS_DELETE'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("ChangeLogObjectButtonAction", {
        attrs: {
          "is-disabled": _vm.disabled,
          "object-id": _vm.currentBuyer.id,
          "object-name": _vm.currentBuyer.name,
          "object-type": "buyer"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }